import React from 'react'

import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className='bg-slate-900 text-slate-300 pt-12 pb-8'>
      <div className='container mx-auto px-4'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 mb-8'>
          {/* Brand Section */}
          <div className='col-span-1 md:col-span-1'>
            <h3 className='text-white text-xl font-bold mb-4 tracking-tight'>
              URBAN<span className='text-premium-500'>AI</span>
            </h3>
            <p className='text-sm leading-relaxed text-slate-400'>
              Experience the future of shopping and events in Zimbabwe. Quality products, seamless payments, and unforgettable experiences.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className='text-white font-semibold mb-4'>Quick Links</h4>
            <ul className='space-y-2 text-sm'>
              <li><a href="/" className='hover:text-premium-400 transition-colors'>Home</a></li>
              <li><a href="/events" className='hover:text-premium-400 transition-colors'>Events</a></li>
              <li><a href="/search" className='hover:text-premium-400 transition-colors'>Search Products</a></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className='text-white font-semibold mb-4'>Support</h4>
            <ul className='space-y-2 text-sm'>
              {/* "/orders" 404'd previously — the real route is "/track-order". */}
              <li><a href="/track-order" className='hover:text-premium-400 transition-colors'>Order Lookup</a></li>
              {/* Privacy Policy / Terms of Service hidden until pages exist;
                  previously shipped as href="#" links that quietly did nothing. */}
            </ul>
          </div>

          {/* Social Media — render only when at least one real URL is configured via env. */}
          {(process.env.REACT_APP_SOCIAL_FACEBOOK_URL ||
            process.env.REACT_APP_SOCIAL_TWITTER_URL ||
            process.env.REACT_APP_SOCIAL_INSTAGRAM_URL ||
            process.env.REACT_APP_SOCIAL_LINKEDIN_URL) && (
            <div>
              <h4 className='text-white font-semibold mb-4'>Follow Us</h4>
              <div className='flex gap-4 text-xl'>
                {process.env.REACT_APP_SOCIAL_FACEBOOK_URL && (
                  <a href={process.env.REACT_APP_SOCIAL_FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className='hover:text-premium-400 transition-all transform hover:scale-110'><FaFacebook /></a>
                )}
                {process.env.REACT_APP_SOCIAL_TWITTER_URL && (
                  <a href={process.env.REACT_APP_SOCIAL_TWITTER_URL} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className='hover:text-premium-400 transition-all transform hover:scale-110'><FaTwitter /></a>
                )}
                {process.env.REACT_APP_SOCIAL_INSTAGRAM_URL && (
                  <a href={process.env.REACT_APP_SOCIAL_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className='hover:text-premium-400 transition-all transform hover:scale-110'><FaInstagram /></a>
                )}
                {process.env.REACT_APP_SOCIAL_LINKEDIN_URL && (
                  <a href={process.env.REACT_APP_SOCIAL_LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className='hover:text-premium-400 transition-all transform hover:scale-110'><FaLinkedin /></a>
                )}
              </div>
            </div>
          )}
        </div>

        <div className='border-t border-slate-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center gap-4'>
          <p className='text-sm text-slate-500 font-medium' title="Jonathan Chaperuka">
            Copyright © {currentYear} UrbanAI Inc. All rights reserved.
          </p>
          <div className='flex items-center gap-2'>
            <span className='h-2 w-2 rounded-full bg-emerald-500'></span>
            <span className='text-xs text-slate-500 font-medium uppercase tracking-widest'>Systems Online</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
